"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessIcon = void 0;
const React = __importStar(require("react"));
function SuccessIcon(props) {
    return (React.createElement("svg", Object.assign({ width: "22", height: "22", fill: "none", viewBox: "0 0 22 22" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11zm6-15l-6.503 6.322-4.103-3.989L5 10.767l5.497 5.345 7.897-7.678L17 7z", clipRule: "evenodd" })));
}
exports.SuccessIcon = SuccessIcon;
